import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const TrackBBlue = ({ state, workState, onLabelClick }) => (
	<g id="TrackBBlue" transform="translate(1330.000000, 809.000000)" className="track">
		<path
			d="M0.930333082,36 C14.1108143,46.7445751 32.6947895,47.8288462 47.0353589,38.6899707 L82.0649159,16.3665364 C89.1699523,11.778737 95.981647,9.26729649 102.5,8.83221491 M113.433924,9.84082459 C116.032925,10.5058269 119.662108,11.7408956 124.321473,13.546031 L141,21.3437837"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeWidth={tracksWidth}
			strokeLinecap="round"/>

		<TrackArrow
			transform="translate(100.896404, 8.868133) rotate(-184.000000) translate(-100.896404, -8.868133) "
			points="104.896404 16.8681329 96.8964036 8.86813285 104.896404 0.868132853"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'TrackBBlue')}
			coords="50.000000, 15.000000"
			text="B"
			textCoordsX="9.0305447"
			textCoordsY="17.5"
			size="small"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>
);

TrackBBlue.propTypes = trackPropTypes;

export default TrackBBlue;
